import { useDispatch, useSelector } from "react-redux";

import { Box } from "@mui/material";
import { AppDialogBox } from "../../common/ui/AppDialogBox";
import AcronymForm from "./AcronymForm";
import { AcronymReducerState } from "../../../interfaces/store/acronymReducerState";
import { actionTypes } from "../../../store/actionTypes/actionTypes";
import { ADMIN } from "../../../constants/admin";

const AcronymFormDialogContainer = () => {
  const dispatch = useDispatch();

  const acronymFormDialogOpen = useSelector(
    (state: { acronym: AcronymReducerState }) => state.acronym.acronymFormOpen
  );

  const acronymFormType = useSelector(
    (state: { acronym: AcronymReducerState }) =>
      state.acronym.acronymFormType
  );

  const dialogTitle =
    acronymFormType === ADMIN.MEETING_FORM_TYPE.EDIT
      ? "Edit Acronym"
      : "Add Acronym";

  // to close the acronym form dialog
  const handleDialogClose = () => {
    dispatch({
      type: actionTypes.OPEN_ACRONYM_FORM,
      payload: false,
    });
    dispatch({
      type: actionTypes.SELECTED_ACRONYM_TABLE_ROW,
      payload: null,
    });
    dispatch({
      type: actionTypes.UPDATE_ACRONYM_TABLE_DATA,
      payload: null,
    });
    dispatch({
      type: actionTypes.UPDATE_ACRONYM_FORM_TYPE,
      payload: ADMIN.MEETING_FORM_TYPE.CREATE,
    });
  };

  return (
    <>
      <AppDialogBox
        btnText1={"test"}
        title={dialogTitle}
        isDialogOpen={acronymFormDialogOpen}
        handleDialogClose={handleDialogClose}
        className='acronym-form-dialog-box-container'
      >
        <Box className='acronym-form-container'>
          <AcronymForm handleDialogClose={handleDialogClose} />
        </Box>
      </AppDialogBox>
    </>
  );
};

export default AcronymFormDialogContainer;

